const BASE_INVENTORY_URL = '/products';

export const INVENTORY_PRODUCTS = (version: string) =>
  `v${version}${BASE_INVENTORY_URL}/inventory`;
